import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneSimpleSmsCode.styl';


Vue.component('BXmakerAuthuserphoneSimpleSmsCode',
    {
        props: {},
        data: function () {
            return {
                //��������� �������� ���� - ��������?
                // ��� ���������� �������� ����� ����� ����� - ��� �������������
                lastActionCheck: false,
            };
        },
        mounted() {
            this.$refs.refInputCode.focus();
        },
        computed: {},
        methods: {
            onInputCode(value) {
                this.$root.setSmsCode(value);
                this.$root.setSmsCodeError(false);

                if (this.$root.smsCodeLength === value.length && this.$root.isFullCaptcha) {
                    this.onClickCheck();
                }
            },
            onClickCheck() {
                this.lastActionCheck = true;
                this.$root.authByPhone();
            },
            onClickChangePhone() {
                this.lastActionCheck = false;
                this.$root.resetMessage();
                this.$root.resetCaptcha();
                this.$root.hideConfirm();
            },
            onClickStart() {
                this.lastActionCheck = false;
                this.$root.setSmsCode('');
                this.$root.setSmsCodeError(false);
                this.$root.startConfirmSmsCode();
            },

            onCompleteCaptcha() {
                if (!this.lastActionCheck) {
                    this.onClickStart();
                    return;
                }

                if (this.$root.smsCodeLength !== this.$root.smsCode.length) {
                    return false;
                }

                this.onClickCheck();
            },
            onCompleteTimeout() {
                this.$root.setSmsCodeTimeout(0);
            }
        },
        template: `
            <div class="bxmaker-authuserphone-simple-smscode"  >
                <slot name="header">
                    <BXmakerAuthuserphoneHeader>
                        {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_SMS_CODE_TITLE}}
                    </BXmakerAuthuserphoneHeader>  
                </slot>
                   
                <slot name="message">
                    <BXmakerAuthuserphoneMessage :message="$root.message" :error="$root.error" /> 
                </slot>                   
                
                <slot name="notice>">    
                    <div class="bxmaker-authuserphone-simple-smscode__notice">
                         {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_SMS_CODE_NOTICE}} 
                         
                         <span class="bxmaker-authuserphone-simple-smscode__phone">{{$root.formattedPhone}}</span>
                         
                         <BXmakerAuthuserphoneLink @onClick="onClickChangePhone">
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_SMS_CODE_CHANGE_PHONE}}
                         </BXmakerAuthuserphoneLink>                     
                    </div>
                </slot>
                {{$root.code}}
                <slot name="code">
                    <BXmakerAuthuserphoneInputCode 
                        :value="$root.smsCode" 
                        @onInput="onInputCode" 
                        @onEnter="onClickCheck" 
                        ref="refInputCode" 
                        :maxLength="$root.smsCodeLength"  
                        :loader="$root.smsCodeCheckLoader"
                        :validationMessage="$root.smsCodeError"
                    />
                </slot>
                               
                <slot name="captcha">
                    <BXmakerAuthuserphoneCaptcha 
                        :code="$root.captchaCode"
                        :src="$root.captchaSrc"
                        :length="$root.captchaLength"
                        :loader="$root.captchaLoader"
                        @onInput="$root.setCaptchaCode"
                        @onComplete="onCompleteCaptcha"
                        @onRefresh="$root.refreshCaptcha"
                   />
                </slot>             
                                
                <slot name="timeout"> 
                    <BXmakerAuthuserphoneTimeout 
                    :timeout="$root.smsCodeTimeout" 
                    v-if="$root.smsCodeTimeout" 
                    @onComplete="onCompleteTimeout" >  
                        <template v-slot:before>
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_SMS_CODE_TIMEOUT_TITLE}} <br>
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_SMS_CODE_TIMEOUT_SUBTITLE}} 
                        </template>                 
                    </BXmakerAuthuserphoneTimeout>
                </slot>
                           
                <slot name="request">
                    <div class="bxmaker-authuserphone-simple-smscode__send"  v-if="!$root.smsCodeTimeout" >
                        <BXmakerAuthuserphoneLink @onClick="onClickStart" v-if="!$root.smsCodeStartLoader">
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_SMS_CODE_GET_NEW}}   
                         </BXmakerAuthuserphoneLink> 
                         <BXmakerAuthuserphoneLoader class="bxmaker-authuserphone-simple-smscode__send-loader" v-else />
                    </div>        
                </slot>        
                                
            </div>
        `,
    });